import { TFunction } from 'i18next';
import Input from '@lib/components/Input/Input';
import { FieldItem } from '@lib/interfaces/form';
import { getDomainValidation } from '@lib/utils/validationUtils';

type FormFieldsArgs = {
  t: TFunction<'translation', undefined>;
};

export const ADD_DOMAIN_FIELD_NAME = 'domain';

export const defaultValues = {
  [ADD_DOMAIN_FIELD_NAME]: '',
};

export default function getAddDomainFormFields({
  t,
}: FormFieldsArgs): FieldItem[] {
  return [
    {
      name: ADD_DOMAIN_FIELD_NAME,
      label: t('domain'),
      element: Input,
      validation: getDomainValidation({ t, required: true }),
    },
  ];
}
